import { AUTH_STORAGE_KEYS } from "@/constants/authStorageKeys";

/** Keys that must not survive logout or account switch (not device prefs). */
export const SESSION_SCOPED_LOCAL_STORAGE_KEYS = [
  AUTH_STORAGE_KEYS.AUTH_DATA,
  AUTH_STORAGE_KEYS.WORKOS_USER,
  AUTH_STORAGE_KEYS.IS_ANI_ADMIN,
  "current_dashboard_id",
  "worker-creation-data",
  "worker-creation-template",
] as const;

/**
 * Remove auth- and user-scoped localStorage entries shared across sessions.
 */
export function clearSessionScopedLocalStorage(): void {
  if (typeof window === "undefined") return;
  for (const key of SESSION_SCOPED_LOCAL_STORAGE_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      // ignore
    }
  }
}
